<template>
  <div class="time-range-new">
    <div class="time-title clearfix">
      <p class="fl date-word">日期/时间</p>
      <div class="fl clearfix">
        <p v-for="(hour, index) in timeArray" :key="index">{{hour}}</p>
      </div>
    </div>
    <div class="time-body" ref="timeBody">
      <ul>
        <li v-for="(day,dayIndex) in selectedTime" :key="dayIndex" class="date-time-panel clearfix">
          <p
            class="fl date-item"
            :class="{disabledTime: setDisabledTime(day)}"
            @click="deleteTime(day, dayIndex)"
          >{{day.date}}</p>
          <ul class="fl time-item clearfix" :class="{disabledTime: setDisabledTime(day)}">
            <li
              v-for="(hour, hourIndex) in timeArray"
              :key="hourIndex"
              :class="{
                disabledTime: setDisabledTime(day, dayIndex, hourIndex),
                disBeforeLine: setDisabledTime(day, dayIndex, hourIndex),
                beforeLine: timeMatrix[dayIndex]&&timeMatrix[dayIndex][hourIndex]&&timeMatrix[dayIndex][hourIndex+1],
                hover:hoverMatrix[dayIndex]&&hoverMatrix[dayIndex][hourIndex]&&hoverMatrix[dayIndex][hourIndex+1]
              }"
              @mousedown="mousedown(day, dayIndex,hourIndex)"
              @mouseup="mouseup(day, dayIndex, hourIndex)"
              @mouseenter="mouseenter(day, dayIndex, hourIndex)"
            >
              <span
                :class="{
                   disabledTime: setDisabledTime(day, dayIndex, hourIndex),
                   disabledBox: setDisabledTime(day, dayIndex, hourIndex)||hoverMatrix[dayIndex]&&hoverMatrix[dayIndex][hourIndex],
                   selectHour: timeMatrix[dayIndex]&&timeMatrix[dayIndex][hourIndex],
                   hoverHour: hoverMatrix[dayIndex]&&hoverMatrix[dayIndex][hourIndex]
                 }"
              ></span>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <!--<div class="batch-setting">-->
    <!--<div class="clearfix batch-top">-->
    <!--<p class="batch-title fl">批量设置</p>-->
    <!--<el-select v-model="startDate" placeholder="开始日期" @change="selectStart">-->
    <!--<el-option-->
    <!--v-for="item in allDate"-->
    <!--:key="item.value"-->
    <!--:label="item.label"-->
    <!--:value="item.value"-->
    <!--:disabled="(new Date(item.label)).getTime()<(new Date()).getTime()- 8.64e7"-->
    <!--&gt;-->
    <!--</el-option>-->
    <!--</el-select> <span class="fl mr10">~</span>-->
    <!--<el-select v-model="endDate" placeholder="结束日期" @change="selectEnd">-->
    <!--<el-option-->
    <!--v-for="item in endDateArray"-->
    <!--:key="item.value"-->
    <!--:label="item.label"-->
    <!--:value="item.value"-->
    <!--:disabled="item.value < startDate || ((new Date(item.label)).getTime()<(new Date()).getTime()- 8.64e7)"-->
    <!--&gt;-->
    <!--</el-option>-->
    <!--</el-select>-->
    <!--<p class="btnGroup fl"><el-button @click="batchSetTime">确定</el-button></p>-->
    <!--</div>-->
    <!--<ul class="time-item clearfix batch-time">-->
    <!--<li v-for="(hour, hourIndex) in timeArray"-->
    <!--:class="{-->
    <!--beforeLine: batchTime[hourIndex] && batchTime[hourIndex+1],-->
    <!--hover: batchBeforeTime[hourIndex]&&batchBeforeTime[hourIndex+1]-->
    <!--}"-->
    <!--&gt;-->
    <!--<span-->
    <!--:class="{-->
    <!--selectHour:batchTime[hourIndex],-->
    <!--hoverHour: batchBeforeTime[hourIndex]-->
    <!--}"-->
    <!--@mousedown="batchDown(hourIndex)"-->
    <!--@mouseup="batchUp(hourIndex)"-->
    <!--@mouseenter="batchEnter(hourIndex)"-->
    <!--&gt;{{hour}}</span>-->
    <!--</li></ul>-->
    <!--</div>-->
  </div>
</template>

<script>
// import {getDayAll} from '../util/date'
export default {
  props: {
    selectedTime: {
      type: Array,
      default: () => {
        return []
      }
    },
    type24: {
      type: Boolean,
      default: true
    },
    dateArray: {
      type: Array,
      default: () => {
        return []
      }
    },
    pageType: {
      type: String
    },
    dateDisable: {
      type: Function,
      default: time => {
        return new Date(time).getTime() < new Date().getTime() - 8.64e7;
      }
    },
    pageInfo: { // 判断当前页面是计划相关还是广告相关
      type: String,
      default: ''
    },
    defaultDate: { // 设置可选的时间范围
      type: Array,
      default: () => {
        return []
      }
    },
    disabledTime: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      timeArray: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      currentTime: '',
      startDate: '',
      endDate: '',
      allDate: [],
      endDateArray: [],
      timeMatrix: [],
      hoverMatrix: [],
      downLi: ['none', 'none'],
      lastOverLi: ['none', 'none'],
      batchTime: [],
      batchBeforeTime: [],
      downBatchLi: 'none',
      lastOverBatchLi: 'none',
      initTimeRange: [],
      defaultTime: []
    }
  },
  created () {
    this.$nextTick(() => {
      this.addEvent(document, 'mouseup', this.documentMouseup)
    })
    if (this.selectedTime.length > 0) {
      this.initStyle()
      this.batchInit()
      this.setTime()
      this.allDate = []
      this.selectedTime.forEach((v, i) => {
        this.allDate.push({
          value: i,
          label: v.date
        })
      })
    }
  },
  beforeDestroy () {
    this.removeEvent(document, 'mouseup', this.documentMouseup)
  },
  methods: {
    initStyle () {
      this.timeMatrix = this.selectedTime.map(() => {
        return this.timeArray.map(() => {
          return false
        })
      })
      this.defaultTime = this.selectedTime.map((res) => {
        return {          date: res.date, time: this.timeArray.map(() => {
            return false
          })        }
      })
      this.initTimeRange = []
      this.hoverMatrix = this.selectedTime.map(() => {
        return this.timeArray.map(() => {
          return false
        })
      })
    },
    setTime () {
      // console.log('setTime: ', this.selectedTime)
      this.selectedTime.map((v, i) => {
        v.time.forEach((t, tIndex) => {
          this.timeMatrix = this.timeMatrix.map((day, index) => {
            return i === index ? day.map((hour, hIndex) => {
              if (hIndex >= +v.time[tIndex][0] && hIndex <= +v.time[tIndex][1]) {
                return true
              } else {
                return hour
              }
            }) : day
          })
        })
      })
      this.timeMatrix.forEach(v => {
        // this.initTimeRange.push(v)
      })
      // console.log(this.timeMatrix)
      if (this.defaultDate.length > 0) {
        this.getTimeRange()
      }
    },
    mousedown (day, dayIndex, hourIndex) {
      // if ((new Date(date)).getTime() + (hourIndex - 7) * 3600 * 1000 < (new Date()).getTime()) { return }
      if (this.setDisabledTime(day, dayIndex, hourIndex)) { return }

      this.downLi = [dayIndex, hourIndex]
    },
    mouseup (day, dayIndex, hourIndex) {
      if (this.downLi[0] === 'none') {
        return
      }
      // if ((new Date(day.date)).getTime() + (hourIndex - 7) * 3600 * 1000 < (new Date()).getTime()) {
      if (this.setDisabledTime(day, dayIndex, hourIndex)) {
        this.$message({
          showClose: true,
          message: '超出时间范围，请重新选择！',
          type: 'warning'
        })
        return
      }
      let startDay = this.downLi[0] > dayIndex ? dayIndex : this.downLi[0]
      let endDay = this.downLi[0] <= dayIndex ? dayIndex : this.downLi[0]
      for (let day = startDay; day <= endDay; day++) {
        this.hoverMatrix.splice(day, 1, this.hoverMatrix[day].map((v, i, row) => {
          return false
        }))
        this.timeMatrix.splice(day, 1, this.timeMatrix[day].map((v, i, row) => {
          if (hourIndex >= this.downLi[1]) {
            return (i >= this.downLi[1] && i <= hourIndex) ? !row[i] : v
          } else {
            return (i <= this.downLi[1] && i >= hourIndex) ? !row[i] : v
          }
        }))
        // this.setIsAllSelected(day)
        this.setValue()
      }
      this.downLi = ['none', 'none']
    },
    mouseenter (day, dayIndex, hourIndex) {
      if (this.downLi[0] === 'none') {
        return
      }
      this.lastOverLi = [dayIndex, hourIndex]
      let startDay = this.downLi[0] > dayIndex ? dayIndex : this.downLi[0]
      let endDay = this.downLi[0] <= dayIndex ? dayIndex : this.downLi[0]
      for (let day = startDay; day <= endDay; day++) {
        this.hoverMatrix.splice(day, 1, this.hoverMatrix[dayIndex].map((v, i, row) => {
          if (hourIndex >= this.downLi[1]) {
            return (i >= this.downLi[1] && i <= hourIndex)
          } else {
            return (i <= this.downLi[1] && i >= hourIndex)
          }
        }))
      }
    },
    documentMouseup () {
      if (this.downLi[0] === 'none') {
        return
      }
      let startDay = this.downLi[0] > this.lastOverLi[0] ? this.lastOverLi[0] : this.downLi[0]
      let endDay = this.downLi[0] <= this.lastOverLi[0] ? this.lastOverLi[0] : this.downLi[0]
      for (let day = startDay; day <= endDay; day++) {
        this.hoverMatrix.splice(day, 1, this.hoverMatrix[day].map((v, i, row) => {
          return false
        }))
      }
      this.hoverMatrix.splice(this.downLi[0], 1, this.hoverMatrix[this.downLi[0]].map(() => {
        return false
      }))
      this.downLi = ['none', 'none']
    },
    addEvent (elem, event, fn) {
      elem.addEventListener ? elem.addEventListener(event, fn, false) : elem.attachEvent('on' + event, fn)
    },
    removeEvent (elem, event, fn) {
      elem.removeEventListener ? elem.removeEventListener(event, fn, false) : elem.detachEvent('on' + event, fn)
    },
    setValue () {
      let result = []
      let groups = []
      let timeArray = []
      var timeArr = this.timeMatrix.map((day, index) => {
        result = []
        groups = []
        day.map((hourFlag, hourIndex) => {
          return hourFlag ? hourIndex : 'none'
        }).filter((v) => {
          // console.log(v !== 'none' && (this.disabledTime[this.selectedTime[index].date] ? this.disabledTime[this.selectedTime[index].date].indexOf(v) === -1 : true))
          return v !== 'none' && (this.disabledTime[this.selectedTime[index].date] ? this.disabledTime[this.selectedTime[index].date].indexOf(v) === -1 : true)
        }).forEach((va, i) => {
          if (groups.length === 0 || groups[groups.length - 1] + 1 !== va) {
            groups = []
            result.push(groups)
          }
          if (groups.length > 1 && groups[groups.length - 1] + 1 === va) {
            groups.splice(groups.length - 1, 1, va)
          } else {
            groups.push(va)
          }
        })
        return result
      })
      timeArr.forEach((time, tIndex) => {
        let temp = []
        let num = this.type24 ? 1 : 0
        time.forEach(t => {
          if (t.length === 1) {
            temp.push(t < 10 ? ['0' + t, '0' + (parseInt(t) + num)] : [t + '', (parseInt(t) + num) + ''])
          } else {
            temp.push(t.map((v, i) => {
              if (i === 1) {
                v = v + num
              }
              return v < 10 ? '0' + v : v + ''
            }))
          }
        })
        let self = this
        // 过滤过期日期或者不在范围内日期
        let dateArr = []
        if (this.defaultDate.length) {
          this.defaultDate.forEach(res => {
            dateArr.push(res.date)
          })
        }
        // (new Date(self.selectedTime[tIndex].date)).getTime() >= (new Date()).getTime() - 8.64e7
        // console.log(self.selectedTime[tIndex].date, !this.dateDisable(self.selectedTime[tIndex].date))
        if (!this.dateDisable(self.selectedTime[tIndex].date)) {
          if (this.defaultDate.length && false) {
            this.defaultDate.forEach(res => {
              dateArr.push(res.date)
            })
            if (dateArr.indexOf(self.selectedTime[tIndex].date) > -1) {
              timeArray.push({
                date: this.selectedTime[tIndex].date,
                time: temp
              })
            }
          } else {
            timeArray.push({
              date: this.selectedTime[tIndex].date,
              time: temp
            })
          }
        }
      })
      this.$emit('checkedTime', timeArray)
    },
    selectStart () {
      this.endDate = ''
      let start = this.allDate[this.startDate] ? new Date(this.allDate[this.startDate].label) : ''
      let temp = []
      this.dateArray.some(v => {
        if (start >= new Date(v[0]) && start <= new Date(v[1])) {
          temp.push(...getDayAll(v[0], v[1]))
        }
      })
      this.endDateArray = []
      temp.forEach(v => {
        let value = 0
        this.allDate.forEach((date, index) => {
          if (v === date.label) value = index
        })
        this.endDateArray.push({
          value: value,
          label: v
        })
      })
    },
    setBatchTime () {
      this.batchTime = this.batchTime.map(() => { return true })
    },
    clearBatchTime () {
      this.batchTime.splice(0, this.batchTime.length, ...(this.batchTime.map(() => { return false })))
      this.batchBeforeTime.splice(0, this.batchBeforeTime.length, ...(this.batchBeforeTime.map(() => { return false })))
    },
    selectEnd () {
      this.setBatchTime()
    },
    selectTime (date, time) {
      let timeAll = event.target.parentNode.parentNode.childNodes[2]
      this.currentTime = date + time
      if (timeAll.style.display === '') {
        this.currentTime = date + time + '1'
      }
    },
    deleteTime (day, index) {
      // if (this.pageType === 'edit') {
      //   this.$message({
      //     showClose: true,
      //     message: '编辑时不可用！',
      //     type: 'warning'
      //   })
      //   return
      // }
      if ((new Date(day.date)).getTime() < (new Date()).getTime() - 8.64e7) {
        return
      }
      this.$emit('deleteTime', { date: day.date, index })
    },
    batchInit () {
      this.batchTime = this.timeArray.map(() => {
        return false
      })
      this.batchBeforeTime = this.timeArray.map(() => {
        return false
      })
    },
    batchDown (hourIndex) {
      if (this.endDate === '') {
        this.$message({
          showClose: true,
          message: '请选择批量设置的时间范围！',
          type: 'warning'
        })
        return
      }
      this.downBatchLi = hourIndex
    },
    batchUp (hourIndex) {
      if (this.downBatchLi === 'none') {
        return
      }
      this.batchBeforeTime = this.batchBeforeTime.map(() => {
        return false
      })
      this.batchTime = this.batchTime.map((v, i, row) => {
        if (hourIndex >= this.downBatchLi) {
          return (i >= this.downBatchLi && i <= hourIndex) ? !row[i] : v
        } else {
          return (i <= this.downBatchLi && i >= hourIndex) ? !row[i] : v
        }
      })
      this.downBatchLi = 'none'
    },
    batchEnter (hourIndex) {
      if (this.downBatchLi === 'none') {
        return
      }
      this.lastOverBatchLi = hourIndex
      this.batchBeforeTime = this.batchBeforeTime.map((v, i) => {
        if (hourIndex >= this.downBatchLi) {
          return (i >= this.downBatchLi && i <= hourIndex)
        } else {
          return (i <= this.downBatchLi && i >= hourIndex)
        }
      })
    },
    batchSetTime () {
      if (this.endDate === '') {
        this.$message({
          showClose: true,
          message: '请选择批量设置的时间范围！',
          type: 'warning'
        })
        return
      }
      for (let day = this.startDate; day <= this.endDate; day++) {
        this.hoverMatrix.splice(day, 1, this.hoverMatrix[day].map((v, i, row) => {
          return false
        }))
        this.timeMatrix.splice(day, 1, this.batchTime)
      }
      this.setValue()
      this.endDate = ''
      this.startDate = ''
      // this.clearBatchTime()
    },
    setDisabledTime (day, dayIndex, hourIndex) {
      const dates = Object.keys(this.disabledTime)
      const dateIndex = dates.indexOf(day.date)
      if (dateIndex > -1) {
        return this.disabledTime[dates[dateIndex]].indexOf(hourIndex) > -1 || this.dateDisable((new Date(day.date)).getTime() + (hourIndex - 7) * 3600 * 1000 - 8.64e7)
      }
      // console.log('disabledTime')
      // return (new Date(day.date)).getTime() + (hourIndex - 7) * 3600 * 1000 < (new Date()).getTime()
      // return ((new Date(day.date)).getTime() + (hourIndex - 7) * 3600 * 1000 < (new Date()).getTime()) || (this.pageInfo === 'advertise' && this.initTimeRange[dayIndex] && !this.initTimeRange[dayIndex][hourIndex])
      return this.dateDisable((new Date(day.date)).getTime() + (hourIndex - 7) * 3600 * 1000 - 8.64e7) || (this.pageInfo === 'advertise' && this.initTimeRange[dayIndex] && !this.initTimeRange[dayIndex][hourIndex])
    },
    getTimeRange () {
      /* this.defaultDate.map((v, i) => {
        v.time.forEach((t, tIndex) => {
          this.defaultTime = this.defaultTime.map((day, index) => {
            return i === index ? day.map((hour, hIndex) => {
              if (hIndex >= +v.time[tIndex][0] && hIndex <= +v.time[tIndex][1]) {
                return true
              } else {
                return hour
              }
            }) : day
          })
        })
      }) */
      this.defaultDate.forEach((v, i) => {
        v.time.forEach((t, tIndex) => {
          this.defaultTime = this.defaultTime.map((day, index) => {
            if (day.date === v.date) {
              return {
                date: day.date,
                time: day.time.map((hour, hIndex) => {
                  if (hIndex >= +v.time[tIndex][0] && hIndex <= +v.time[tIndex][1]) {
                    return true
                  } else {
                    return hour
                  }
                })
              }
            } else {
              return day
            }
          })
        })
      })
      this.initTimeRange = []
      this.defaultTime.forEach(v => {
        this.initTimeRange.push(v.time)
      })
    }
  },
  watch: {
    selectedTime () {
      if (this.selectedTime.length > 0) {
        this.initStyle()
        this.batchInit()
        this.setTime()
        this.allDate = []
        this.selectedTime.forEach((v, i) => {
          this.allDate.push({
            value: i,
            label: v.date
          })
        })
        // console.log('selectedTime')
        this.setValue()
      }
    },
    defaultDate () {
      this.getTimeRange()
    }
  }
}
</script>

<style lang="scss">
.slide-enter-active {
  transition: all 0.3s ease-in;
}
.slide-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-enter,
.slide-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
.disabledTime {
  cursor: not-allowed !important;
}
.time-range-new {
  color: #333;
  padding: 5px 10px;
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  .time-title {
    div > p {
      float: left;
      width: 18px;
      height: 21px;
      margin: 8px 0 0 3px;
      font-size: 13px;
    }
    .date-word {
      margin: 8px 0px 0;
      width: 74px;
      height: 21px;
      line-height: 21px;
      text-align: center;
      font-size: 14px;
    }
  }
  .time-body {
    max-height: 180px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .date-time-panel {
    margin-bottom: 10px;
    cursor: pointer;
  }
  .date-item {
    height: 18px;
    line-height: 18px;
    margin-right: 3px;
    font-size: 13px;
    text-align: center;
    color: #3dc1c4;
    cursor: pointer;
    &::selection {
      background: transparent;
    }
  }
  .batch-setting {
    padding-top: 10px;
    .batch-title {
      float: left;
      font-size: 13px;
      width: 54px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      margin: 0 13px 0 10px;
    }
    .mr10 {
      margin-right: 10px;
    }
    .btnGroup {
      button {
        background: #fff;
        border: 1px solid #c4c4c4;
        color: #1f2d3d;
      }
      button:hover {
        color: #3dc1c4;
        border-color: #3dc1c4;
      }
    }
    .batch-time {
      span {
        position: relative;
        z-index: 10;
        font-size: 10px;
        text-align: center;
        color: #fff;
        &::selection {
          background: transparent;
        }
      }
    }
    .el-select {
      float: left;
      width: 100px;
      margin-right: 10px;
    }
    .el-input__inner {
      color: #0f1a23;
      font-size: 13px;
      text-align: center;
      height: 25px;
      width: 100px;
      padding: 1px 0;
    }
    .el-input__icon + .el-input__inner {
      padding-right: 20px;
    }
    .el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover,
    .el-select-dropdown__item.hover,
    .el-select-dropdown__item:hover {
      background-color: #3dc1c4;
      color: #fff;
    }
    .el-input__inner::-webkit-input-placeholder {
      /* WebKit browsers*/
      color: #3c3c3c;
      font-size: 14px;
    }
    .el-input__inner:-moz-placeholder {
      /* Mozilla Firefox 4 to 18*/
      color: #3c3c3c;
      font-size: 14px;
    }
    .el-input__inner::-moz-placeholder {
      /* Mozilla Firefox 19+*/
      color: #3c3c3c;
      font-size: 14px;
    }
    .el-input__inner:-ms-input-placeholder {
      /* Internet Explorer 10+*/
      color: #3c3c3c;
      font-size: 14px;
    }
    .el-select-dropdown__item {
      text-align: center;
    }
    .el-select .el-input .el-input__icon {
      width: 20px;
      color: #3dc1c4;
      font-size: 10px;
    }
    .el-select-dropdown__item.selected,
    .el-select-dropdown__item.selected.hover {
      background-color: #3dc1c4;
      color: #fff;
    }
    .el-select .el-input__inner:focus {
      border-color: #48576a;
    }
    .el-input__icon + .el-input__inner {
      padding: 0 18px 0 5px;
    }
    .time-item {
      margin-left: 75px;
    }
  }
  .time-item {
    p,
    li {
      position: relative;
      float: left;
      margin-left: 3px;
      width: 18px;
      height: 18px;
      cursor: pointer;
      span {
        display: block;
        /*margin: 0 5px;*/
        width: 16px;
        height: 16px;
        line-height: 16px;
        background: #d4d4d4;
        border-radius: 50%;
        cursor: pointer;
      }
      .selectHour {
        background: #66cfa7;
      }
      .disabledBox {
        background: #fc8675;
      }
      .hoverHour {
        background: #abdac8;
      }
    }
    .beforeLine::before {
      position: absolute;
      content: "";
      display: inline-block;
      height: 16px;
      width: 20px;
      left: 10px;
      top: 0;
      background-color: #66cfa7;
    }
    .disBeforeLine::before {
      background-color: #fc8675;
    }
    .hover::before {
      position: absolute;
      content: "";
      display: inline-block;
      height: 16px;
      width: 20px;
      left: 10px;
      top: 0;
      background-color: #abdac8;
    }
  }
}
</style>
